import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import App from "./App";
import awsExports from "./aws-exports.js";
import "./index.css";

const runtimeOrigin = window.location.origin;
const restEndpoints = (awsExports as any).aws_cloud_logic_custom ?? [];

const amplifyConfig: any = {
  ...awsExports,
  oauth: {
    ...awsExports.oauth,
    redirectSignIn: runtimeOrigin,
    // Cognito signout callback must use an allowed sign-out URL.
    redirectSignOut: `${runtimeOrigin}/logout`
  }
};

if (restEndpoints.length > 0) {
  amplifyConfig.API = {
    ...((awsExports as any).API ?? {}),
    endpoints: restEndpoints
  };
}

Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);
